/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import React, { useEffect, useRef } from 'react';

import {
    HorizontalScrollBlockContainerStyled,
    HorizontalScrollBlockStyled,
    HorizontalScrollStyled,
} from '../../../components/Table/styled/TableStyled';

interface ITableHorizontalScrollProps {
    tableRef: React.RefObject<HTMLDivElement>;
    totalColumnsWidth: number;
}

const TableHorizontalScroll = ({ tableRef, totalColumnsWidth }: ITableHorizontalScrollProps) => {

    const tableHorScrollContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        horizontalScrollHandler();
    });

    const horizontalScrollHandler = (): void => {
        if (tableRef.current && tableHorScrollContainerRef.current) {
            const scrolled = tableHorScrollContainerRef.current.scrollLeft > 0;
            scrolled
                ? tableRef.current.classList?.add('scrolled')
                : tableRef.current.classList?.remove('scrolled');

            tableRef.current.querySelector('.rt-thead')?.scrollTo({ left: tableHorScrollContainerRef.current.scrollLeft });
            tableRef.current.querySelector('.rt-tbody')?.scrollTo({ left: tableHorScrollContainerRef.current.scrollLeft });
        }
    };

    return (
        <HorizontalScrollBlockContainerStyled>
            <HorizontalScrollBlockStyled
                marginLeft={0}
                ref={tableHorScrollContainerRef}
                width={`${tableRef.current?.clientWidth ?? 1}px`}
                onScroll={horizontalScrollHandler}
            >
                <HorizontalScrollStyled style={({ width: totalColumnsWidth })}/>
            </HorizontalScrollBlockStyled>
        </HorizontalScrollBlockContainerStyled>
    );
};

export default TableHorizontalScroll;
